export default {
  apiKey: "AIzaSyBwFsI5UWozqYi5TrO2BOUYVBECzr6r43E",
  authDomain: "correla-app.firebaseapp.com",
  databaseURL: "https://correla-app.firebaseio.com",
  projectId: "correla-app",
  storageBucket: "correla-app.appspot.com",
  messagingSenderId: "963552926535",
  appId: "1:963552926535:web:9cc6603c2c4960ab",
  measurementId: "G-GMNZSFHZ8V",
};
